<template>
    <div class="attachments">
        <div class="attachments__wrapper ma-6">
            <div class="attachments-wrapper__title font-weight-bold text--secondary">
                <h2> {{ documentName }}</h2>
            </div>
            <hr class="mb-4" />
            <div class="attachments-wrapper__title font-weight-bold mb-4">
                {{ $t("attachments.title") }}
            </div>
            <Alerts v-if="!uploadedFiles.length && showAlert" :alertType="alertType" :alertMsg="alertMsg" />


            <div class="attachments__dropzone-title font-weight-bold">
                {{ $t("attachments.doc-list-title") }}
            </div>
            <div class="attachments__dropzone-area mt-3">
                <custom-dropzone-component @files="uploadFiles" />
            </div>

            <div v-for="(file, index) in uploadedFiles" :key="index" class="custom-dropzone__file-item">
                <div class="file-name overflow-hidden">
                    <span class="bullet"></span>
                    <span class="text-truncate">{{ getTrimmedFileName(file.filename) }}</span>
                </div>
                <div>
                    <v-icon @click="removeFile(index)">mdi-delete</v-icon>
                    <!-- <a @click="downloadFile(index)"><v-icon>mdi-download</v-icon></a> -->
                </div>
            </div>


        </div>
        <div class="footer-message">
            <div>
                <v-row>
                    <v-container class="py-0 fill-height">
                        <div class="col-md-12 col-12 reject pr-0 mt-6 text-center">
                            <v-btn large color="#f36e21" class="sign-reject-btn w-100" block dark @click="save()">
                                {{ $t("attachments.button-text") }}
                            </v-btn>
                        </div>
                    </v-container>
                </v-row>
            </div>
        </div>
        <default-loading v-if="loading" :loading="loading" />
    </div>
</template>

<script>
import CustomDropzoneComponent from '../shared/Dropzone.component.vue'
import UploadService from '../../services/multiple/upload-service.js'
import DefaultLoading from "../shared/DefaultLoading.component"
import Alerts from "../shared/Alerts.component";
import { mapGetters } from 'vuex';

export default {
    components: {
        CustomDropzoneComponent,
        DefaultLoading,
        Alerts
    },
    data() {
        return {
            loading: false,
            uploadedFiles: [],
            showAlert: false,
            alertType: "",
            alertMsg: "",
            token: null,
            authId: null,
            currentDocument: null,
            documentName: ""
        }
    },
    computed: {
        getTrimmedFileName() {
            return (fileName) => {
                const maxLength = 100
                if (fileName.length > maxLength) {
                    const trimmedName = fileName.substring(0, maxLength - 3) + '...';
                    return trimmedName
                }
                return fileName
            }
        },
        hasSignerForm() {
            return this.$store.getters['forms/hasSignerForm']
        },
        hasPendingSignerForm() {
            return this.$store.getters['forms/hasPendingSignerForm']
        },
        hasAssociation() {
            return this.$store.getters['common/hasAssociation']
        },
        currentRoute() {
            return this.$route;
        },
        documentCheckList() {
            return localStorage.getItem("documentCheckList") ? JSON.parse(localStorage.getItem("documentCheckList")) : [];
        },
        ...mapGetters('forms', [
            'hasSignerForm', 'hasPendingSignerForm'
        ])
    },
    methods: {
        async loadAttachments() {

            if (this.$route.query.token) {
                const attachments = await UploadService.getAttachments(this.$route.params.id, this.$route.query.token, this.$route.query.auth_id);
                this.uploadedFiles = attachments.data
            }
        },
        setAlert(show, alertType, alertMsg) {
            this.showAlert = show;
            this.alertType = alertType;
            this.alertMsg = alertMsg;
        },
        async save() {
            try {

                let documentCheckList = localStorage.getItem("documentCheckList") ? JSON.parse(localStorage.getItem("documentCheckList")) : [];

                await this.loadFormStatus(); // Wait for loadFormStatus to complete

                if (this.uploadedFiles.length > 0) {
                    // Check for any signer forms
                    for (let i = 0; i < documentCheckList.length; i++) {
                        if (documentCheckList[i].documentId == this.$route.params.id) {
                            documentCheckList[i].attachmentsChecked = true;


                            localStorage.setItem('documentCheckList', JSON.stringify(documentCheckList));
                            // Check if there is a next element in the array
                            if (i + 1 < documentCheckList.length) {


                                // Modify the next element here
                                if ((documentCheckList[i + 1].checkAttachments) && (!documentCheckList[i + 1].attachmentsChecked)) {
                                    let newPath = this.$router.resolve({
                                        name: `${this.hasAssociation ? 'custom-' : ''}multiple-attachments`,
                                        params: { id: documentCheckList[i + 1].documentId },
                                        query: {
                                            token: documentCheckList[i + 1].documentToken,
                                            auth_id: documentCheckList[i + 1].auth_id,
                                            document_name: documentCheckList[i + 1].documentName
                                        }
                                    }).href;

                                    const extractBasePath = (path) => {
                                        const segments = path.split('/');
                                        // Assuming the ID is always after the base segment (e.g., /multiple-attachments/ID)
                                        if (segments.length > 2) {
                                            return segments.slice(0, 2).join('/'); // Adjust index based on your URL structure
                                        }
                                        return path;
                                    };

                                    const currentBasePath = extractBasePath(this.$route.path);
                                    const newBasePath = extractBasePath(new URL(newPath, window.location.origin).pathname);

                                    if (currentBasePath === newBasePath) {
                                        console.log('identical base paths');
                                        // If the new path is the same as the current path, reload the page
                                        window.location.href = newPath; // Changes the URL and reloads the page
                                    }

                                }
                            } else {


                                this.navigateToDocument();

                            }
                            break; // Break after modifying the current and next elements if needed
                        }
                    }
                } else {
                    this.setAlert(true, 'error', this.$t("attachments.upload-required-message"));
                }
            } catch (error) {
                console.error('Error in save method:', error);
            }
        },
        async uploadFiles(files) {
            this.loading = true
            const response = await UploadService.uploadAttachments(this.$route.params.id, files, this.$route.query.token, this.$route.query.auth_id)
            this.uploadedFiles.push(response.data)
            this.loading = false

        },
        async downloadFile(index) {
            this.loading = true
            const response = await UploadService.downloadAttachments(this.$route.params.id, this.uploadedFiles[index].id, this.token, this.authId)
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const url = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = 'document.pdf'
            link.click()
            URL.revokeObjectURL(url)
            this.loading = false
        },
        async removeFile(index) {
            this.loading = true
            await UploadService.removeAttachments(this.$route.params.id, this.uploadedFiles[index].id, this.token, this.authId)
            this.uploadedFiles.splice(index, 1)
            this.loading = false
        },
        findCurrentDocument() {
            // let currentDoc = this.documentCheckList.filter((document) => document.documentId == this.currentRoute.params.id);
            // this.currentDocument = currentDoc && currentDoc.length ? currentDoc[0] : null;
            this.loadAttachments();

        },
        async loadFormStatus() {
            console.log('token is ' + this.token);
            try {
                const response = await this.$store.dispatch('forms/getMultipleFormStatus', {
                    requestId: this.$route.params.id,
                    token: this.token,
                    authId: this.$route.query.auth_id
                });
                return response;
            } catch (error) {
                console.error('Error loading form status:', error);
                throw error; // Re-throw the error to be caught in the save method
            }
        },
        navigateToDocument() {

            console.log(' NAVIGATING... ');
            // Define a variable to determine the route name
            let routeName, matchingDocument;

            // Check if there is any document with hasSignerForm true
            const anySignerForm = this.documentCheckList.some(document => document.hasSignerForm);

            if (!anySignerForm) {
                // No documents have hasSignerForm, navigate to multiple-pdf
                routeName = `${this.hasAssociation ? 'custom-' : ''}multiple-pdf`;
            } else {
                // Check if no documents have hasPendingSignerForm true
                const anyPendingSignerForm = this.documentCheckList.some(document => document.hasPendingSignerForm);

                if (!anyPendingSignerForm) {
                    // No documents have hasPendingSignerForm, navigate to multiple-pdf
                    routeName = `${this.hasAssociation ? 'custom-' : ''}multiple-pdf`;
                } else {
                    // If there is a document with hasSignerForm and any hasPendingSignerForm, navigate to the default multiple-attachmentsforms
                    routeName = `${this.hasAssociation ? 'custom-' : ''}multiple-forms`;
                    matchingDocument = this.documentCheckList.find(document => document.hasSignerForm && document.hasPendingSignerForm);
                }
            }



            if (!routeName) {
                // If routeName is not set, default to multiple-attachments
                routeName = `${this.hasAssociation ? 'custom-' : ''}multiple-attachments`;
            }

            // Handle the outcome based on the found document
            if (matchingDocument) {
                this.navigateTo(matchingDocument, routeName);
            } else if (routeName) {
                // Navigate to routeName even without a matching document
                this.$router.push({ name: routeName });
            } else {
                console.log("No matching document found");
            }
        },
        navigateTo(document, routeName) {
            // Resolve the new path using a dynamic route name
            const newPath = this.$router.resolve({
                name: routeName,
                params: { id: document.documentId },
                query: {
                    token: document.documentToken,
                    auth_id: document.auth_id,
                    document_name: document.documentName
                }
            }).href;

            const extractBasePath = (path) => {
                const segments = path.split('/');
                if (segments.length > 2) {
                    return segments.slice(0, 2).join('/'); // Adjust index based on your URL structure
                }
                return path;
            };

            const currentBasePath = extractBasePath(this.$route.path);
            const newBasePath = extractBasePath(new URL(newPath, window.location.origin).pathname);

            if (currentBasePath === newBasePath) {
                // If the new path is the same as the current path, reload the page
                window.location.href = newPath;
            } else {
                // Otherwise, use Vue Router to navigate with the dynamic route name
                this.$router.push({
                    name: routeName,
                    params: { id: document.documentId },
                    query: {
                        token: document.documentToken,
                        auth_id: document.auth_id,
                        document_name: document.documentName
                    }
                });
            }
        }
    },
    mounted() {

        // if (this.currentRoute && this.currentRoute.params.id) {
        this.findCurrentDocument()
        // }
    },
    created() {
        this.token = this.$route.query.token || null;
        this.authId = this.$route.query.auth_id || null;
        this.documentName = this.$route.query.document_name || "";
    },

}
</script>

<style scoped>
.attachments__wrapper {
    background: #f9f9f9;
    padding: 20px;
    border-radius: 10px;
}

.attachments-wrapper__title {
    font-size: 18px;
    margin-bottom: 10px;
}

.custom-dropzone__file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin: 5px 0;
    background: rgba(243, 110, 33, 0.1);
    /* Light background color derived from theme color */
    border: 1px solid #ddd;
    border-radius: 5px;
}

.custom-dropzone__file-item v-icon {
    cursor: pointer;
}

.file-name {
    display: flex;
    align-items: center;
}

.bullet {
    width: 10px;
    height: 10px;
    background-color: #f36e21;
    border-radius: 50%;
    display: inline-block;
    margin-right: 10px;
}

.custom-dropzone__file-item {
    display: flex;
    justify-content: space-between;
}
</style>